import React, { useContext } from "react";
import {
  Sheet,
  SheetContent,
  SheetFooter,
  SheetHeader,
  SheetTitle,
} from "@/components/ui/sheet";
import { LanguageProviderContext } from "@/providers/LanguageProvider";

interface ProductQueueListSheetProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  children: React.ReactNode;
  footer: React.ReactNode;
  title: string;
  totalQueued: number;
  queueDrawerOpen: boolean;
  setQueueDrawerOpen: (open: boolean) => void;
}

export default function ProductQueueListSheet({
  children,
  footer,
  totalQueued,
  queueDrawerOpen,
  setQueueDrawerOpen,
}: ProductQueueListSheetProps) {
  const { translator } = useContext(LanguageProviderContext);

  return (
    <Sheet open={queueDrawerOpen} onOpenChange={setQueueDrawerOpen}>
      <SheetContent
        side="right"
        className="w-[calc(100vw-0.5rem)] sm:w-[400px] max-w-none sm:max-w-[400px] top-2 h-[calc(100dvh-1rem)] max-h-[calc(100dvh-1rem)] p-0 flex flex-col gap-0 rounded-l-lg border-y border-l"
      >
        <SheetHeader className="p-4 pb-3 border-b shrink-0 space-y-1 text-left">
          <SheetTitle className="text-base">
            {translator("ProductsCatalog.stagedItemsTitle")}
            <span className="text-green-500"> ({totalQueued})</span>
          </SheetTitle>
        </SheetHeader>
        <div className="flex flex-1 min-h-0 flex-col px-4 pb-4 pt-2 overflow-hidden">
          {children}
        </div>
        <SheetFooter className="p-4">
          {footer}
        </SheetFooter>
      </SheetContent>
    </Sheet>
  );
}
